<!--The content below is only a placeholder and can be replaced.-->
<app-top-bar></app-top-bar>
<router-outlet></router-outlet>
